var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.235 2.61875C11.4735 1.85625 10.2376 1.85625 9.47617 2.61875L3.73385 8.36875C2.41998 9.68438 2.41998 11.8156 3.73385 13.1313C5.04771 14.4469 7.17612 14.4469 8.48999 13.1313L13.2336 8.38125C13.5738 8.04063 14.1293 8.04063 14.4695 8.38125C14.8097 8.72188 14.8097 9.27813 14.4695 9.61875L9.72583 14.3688C7.7285 16.3688 4.49533 16.3688 2.498 14.3688C0.500668 12.3688 0.500668 9.13125 2.498 7.13125L8.24032 1.38125C9.68526 -0.065622 12.0259 -0.065622 13.4708 1.38125C14.9158 2.82813 14.9158 5.17188 13.4708 6.61875L7.97817 12.1188C7.08561 13.0125 5.63755 13.0125 4.74499 12.1188C3.85244 11.225 3.85244 9.775 4.74499 8.88125L9.23899 4.38125C9.57915 4.04063 10.1347 4.04063 10.4748 4.38125C10.815 4.72188 10.815 5.27813 10.4748 5.61875L5.98084 10.1188C5.77175 10.3281 5.77175 10.6719 5.98084 10.8813C6.18994 11.0906 6.53323 11.0906 6.74232 10.8813L12.235 5.38125C12.9965 4.61875 12.9965 3.38125 12.235 2.61875Z",
    fill: "#929596"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadDisabled);
export default __webpack_public_path__ + "static/media/icon-upload-disabled.67fef1a9f67e8a6ad116bca44faad13b.svg";
export { ForwardRef as ReactComponent };